import { useCallback, useEffect } from "react";
import {
  useCurrentRefinements,
  useHits,
  usePagination,
} from "react-instantsearch";
import { useLocation, useNavigate } from "react-router-dom";

import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { useScrollToPageTopOnMount } from "@tudigo-monorepo/core-tudigo-utils";

import { SearchProjectsPagination } from "../../shared-internal/components/search-projects/search-projects-pagination";
import { DefaultStartedProjectsLayout } from "./default-started-projects-layout";
import { SelectableProjectsCardGrid } from "./selectable-projects-card-grid";

export function StartedProjectsContent() {
  const { hits } = useHits();
  const { canRefine: hasRefinements } = useCurrentRefinements();
  const { refine: paginate } = usePagination();
  const location = useLocation();
  const navigate = useNavigate();

  // Reset pagination and clear location state
  const clearPagination = useCallback(() => {
    paginate(0);
    navigate(location.pathname, { replace: true });
  }, [paginate, navigate, location.pathname]);

  useEffect(() => {
    if (location.state?.from === "/financed") {
      clearPagination();
    }
  }, [location.state, clearPagination]);

  const { scroller } = useScrollToPageTopOnMount();

  return (
    <div ref={scroller} className="container mx-auto px-4 py-6 md:py-10">
      {hasRefinements ? (
        <SelectableProjectsCardGrid projects={hits as any as Project[]} />
      ) : (
        <DefaultStartedProjectsLayout />
      )}
      <SearchProjectsPagination
        onPageChange={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    </div>
  );
}
